import { LicenseResponse } from './littlesis-licensing.service';

export const testResponse: LicenseResponse = {
    success: true,
    response: {
      domain: 'gafetest.com',
      subscriptions: {
        'ait-lsp': {
          key: 'ait-lsp',
          handle: 'ait-lsp',
          id: 5501341,
          plan: {
            name: 'Trial',
            timestamp: '2021-11-05T11:56:47-04:00'
          },
          expiry: new Date('2022-03-01T01:00:00-04:00'),
          bundle: 'TBC'
        }
      }
    }
  };

